import { createFileRoute, redirect } from "@tanstack/react-router";
import { paths } from "src/paths";

export const Route = createFileRoute("/_authenticated/conta/seguranca/")({
  beforeLoad: () => {
    throw redirect({ to: paths.dashboard.account.general });
  },
});
